export default __webpack_public_path__ + "static/media/share.e670caf3.svg";